export const EventIds = {
  BidSyncStarted: 1,
  BidSyncFinished: 2,
  BidSyncSkipped: 4,
  BidSyncCheck: 5,
  BidSubmissionSendToAemoFailed: 6,
  BidSubmissionSendToAemoSuccess: 7
};
